import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGravatarComponent } from './simple-icons-gravatar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGravatarComponent ],
    exports:      [ SimpleIconsGravatarComponent ],
    bootstrap:    []
})
export class SimpleIconsGravatarModule {}
